module.exports = __webpack_public_path__ + "static/media/LOGO-IA-LATINAD.29409b40.png";